import { useMutation } from '@tanstack/react-query';
import { userService, ChangePasswordRequest, ChangePasswordResponse } from '@/services/userService';

interface UseChangePasswordOptions {
  onSuccess?: (data: ChangePasswordResponse) => void;
  onError?: (error: Error) => void;
}

export const useChangePassword = (options?: UseChangePasswordOptions) => {

  return useMutation({
    mutationFn: async (passwordData: ChangePasswordRequest) => {
      return userService.changePassword(passwordData);
    },
    onSuccess: (data) => {
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      options?.onError?.(error);
    },
  });
};
